import React from 'react'
import { Theme } from '@material-ui/core'
import Tooltip from '@material-ui/core/Tooltip'
import PictureAsPdfIcon from '@material-ui/icons/PictureAsPdf'
import TableChartIcon from '@material-ui/icons/TableChart'
import { DeliverableValueStatus } from '../../../../../models'
import { DeliverableValueStatusConfig } from '../../../../../models/DocumentAudit/services'

interface StatusIconProps {
    status: DeliverableValueStatus
    theme: Theme
}

export const StatusIcon: React.FC<StatusIconProps> = ({ status, theme }) => {
    // Check for special statuses first
    if (status === 'MISSING_RENT_ROLL') {
        return (
            <Tooltip title="Missing Rent Roll" placement="top">
                <div
                    style={{
                        display: 'flex',
                        flexDirection: 'column',
                        alignItems: 'center',
                        justifyContent: 'center',
                    }}
                >
                    <PictureAsPdfIcon
                        style={{
                            fontSize: 18,
                            color: theme.palette.warning.dark,
                        }}
                    />
                    <span
                        style={{
                            color: theme.palette.warning.dark,
                            fontSize: '10px',
                            fontWeight: 'bold',
                            marginTop: '2px',
                        }}
                    >
                        DOC
                    </span>
                </div>
            </Tooltip>
        )
    }

    if (status === 'MISSING_DOCUMENT') {
        return (
            <Tooltip title="Missing Document" placement="top">
                <div
                    style={{
                        display: 'flex',
                        flexDirection: 'column',
                        alignItems: 'center',
                        justifyContent: 'center',
                    }}
                >
                    <TableChartIcon
                        style={{
                            fontSize: 18,
                            color: theme.palette.warning.dark,
                        }}
                    />
                    <span
                        style={{
                            color: theme.palette.warning.dark,
                            fontSize: '10px',
                            fontWeight: 'bold',
                            marginTop: '2px',
                        }}
                    >
                        RR
                    </span>
                </div>
            </Tooltip>
        )
    }

    // For other statuses, use the original implementation
    const statusConfig = DeliverableValueStatusConfig[status]
    const IconComponent = statusConfig.icon.component

    return (
        <Tooltip
            title={status
                .replace(/_/g, ' ')
                .toLowerCase()
                .replace(/\b\w/g, (c) => c.toUpperCase())}
            placement="top"
        >
            <div
                style={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    width: '26px',
                    height: '26px',
                    padding: '2px',
                    borderRadius: '50%',
                    backgroundColor:
                        status === 'NOT_MATCHED'
                            ? 'rgba(244, 67, 54, 0.1)'
                            : 'transparent',
                }}
            >
                <IconComponent
                    style={{
                        color: statusConfig.icon.color,
                        fontSize: '20px',
                    }}
                />
            </div>
        </Tooltip>
    )
}
